import { toPng } from 'html-to-image';

export const ExportToImage = async (
  elementIds: string[],
  fileName: string = 'exported-image.png',
  excludeElementId: string | null = null
) => {
  try {
    const imageArray: HTMLImageElement[] = [];

    let excludedElement: HTMLElement | null = null;
    if (excludeElementId) {
      excludedElement = document.getElementById(excludeElementId);
      if (excludedElement) {
        excludedElement.style.visibility = 'hidden';
      }
    }

    for (const id of elementIds) {
      const element = document.getElementById(id);
      if (element) {
        const dataUrl = await toPng(element, { backgroundColor: 'white' });
        const img = new Image();
        img.src = dataUrl;
        await new Promise((resolve) => (img.onload = resolve));
        imageArray.push(img);
      } else {
        console.warn(`Element with ID ${id} not found.`);
      }
    }

    if (excludedElement) {
      excludedElement.style.visibility = 'visible';
    }

    if (imageArray.length > 0) {
      const combinedCanvas = document.createElement('canvas');
      const ctx = combinedCanvas.getContext('2d')!;
      const totalWidth = Math.max(...imageArray.map((img) => img.width));
      const totalHeight = imageArray.reduce((sum, img) => sum + img.height, 0);

      combinedCanvas.width = totalWidth;
      combinedCanvas.height = totalHeight;

      let offsetY = 0;
      for (const img of imageArray) {
        ctx.drawImage(img, 0, offsetY);
        offsetY += img.height;
      }

      const link = document.createElement('a');
      link.download = fileName;
      link.href = combinedCanvas.toDataURL('image/png');
      link.click();
    }
  } catch (error) {
    console.error('Failed to export image:', error);
  }
};
